import { showElement, hideElement, isLoggedIn } from "./helper";

export function unlockArticles() {
    if (isLoggedIn()) {
        const user = IwwUserdata.USERDATA;
        // In Artikeldetail Elemente ein- bzw. ausblenden
        showElement(user.infodienste.map((element) => "open_article_" + element));
        hideElement(user.infodienste.map((element) => "closed_article_" + element));

        showElement(user.infodienste.map((element) => "open_download_" + element));
        hideElement(user.infodienste.map((element) => "closed_download_" + element));

        showElement(user.infodienste.map((element) => "share_article_open_" + element));
        hideElement(user.infodienste.map((element) => "share_article_closed_" + element));

        // Artikelteaser holen
        hideElement(user.infodienste.map((element) => "closed_artikel_teaser_" + element));

        for (let i = 0; i < user.infodienste.length; i++) {
            let string = "closed_artikel_teaser_" + user.infodienste[i];

            const closed_artikel_teaser = document.querySelectorAll('[id^="' + string + '"]');

            // Schloss ausblenden wenn Abo vorhanden
            for (let i = 0; i < closed_artikel_teaser.length; i++) {
                closed_artikel_teaser[i].style.display = 'none';
            }

            let string_download = "closed_download_teaser_" + user.infodienste[i];

            const closed_download_teaser = document.querySelectorAll('[id^="' + string_download + '"]');

            // Schloss ausblenden wenn Abo vorhanden
            for (let i = 0; i < closed_download_teaser.length; i++) {
                closed_download_teaser[i].style.display = 'none';
            }
        }
    }
}






